import React, { useState } from 'react';
import { milestone } from '../../auth/auth';
import Loader from '../../partial/Loader';
import { useNavigate } from 'react-router-dom';
import { formatPoints } from '../../../utils/helper';


const initialReviewData = {
  goal: { title: 'Luxury stay at Taj for 4 nights', points: 25000 },
  timeline: { duration: '6 Months', endDate: 'November 20, 2025' },
  commitments: [
    { title: 'Upload Invoices', target: '₹4L in invoices', points: 400 },
    { title: 'ERP Daily Sync', target: '5 days', points: 7500 },
    { title: 'Onboard Retailers', target: '2 retailers', points: 1000000 },
  ],
  bonusActivities: [
    { title: 'Refer Brands', committed: '4 referrals' },
    { title: 'Refer Distributors', committed: '5 referrals' },
  ],
};

const ReviewContent = ({ updateFormData, setActiveSection, formData }) => {

  const navigate = useNavigate()
  const [reviewData, setReviewData] = useState(initialReviewData);
  const [loader, setLoader] = useState(false);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const handleConfirm = async () => {
    setLoader(true);
    try {
      const customerId = localStorage.getItem("customerid");

      const body = {
        Customer: {
          companyid: customerId,
          status: "inprogress"
        },
        RewardsDetails: formData?.Activity?.RewardsDetails,
        Timeline: formData?.Activity?.Timeline,
        Activity: formData?.Activity?.Activity,
        BonusActivities: formData?.Activity?.BonusActivities,
      };
let token = await JSON.parse(localStorage.getItem("token_gen"));
      const response = await milestone(token.access_token, body);
      if (response?.message === "EarningMilestone data created successfully.") {

        navigate("/reward?tab=track_timeline", { state: { milestone: true } });
      }
    } catch (error) {
      console.error("Error in handleConfirm:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleBack = () => {
    setActiveSection("activities_timeline");
  };

  const handleClosePopup = () => {
    setShowAddressPopup(false); 
  };

  return (
    <main>
      <div className="timeline">
        {loader && <Loader />}
        {showAddressPopup && (
          <div className="popup show" id="congratulationspopup">
            <div className="popup-box">
              <a
                href="javascript:void(0)"
                className="close-popup"
                id="closecongratulationspopup"
                onClick={handleClosePopup}
              >
                X
              </a>
              <div className="popup-box-congratulations">
                <span>
                  <img src="images/confetti.png" alt="Confetti" />
                </span>
                <h4>Congratulations</h4>
                <p>You're one step closer to achieving your reward. Keep tracking your progress to reach your goal!</p>
                <a href="javascript:void(0)" className="btn btn-block" onClick={handleClosePopup}>
                  Back to Home
                </a>
              </div>
            </div>
          </div>
        )}

        <div className="timeline-content">
          <div className="timeline-content-inner active" id="review_timeline">
            <div className="timeline-review">
              <div className="timeline-review-box">
                <div className="timeline-review-box-header">
                  <h4>Review Your Goals</h4>
                </div>
                <div className="timeline-review-box-body">
                  <div className="timeline-review-box-body-inner">
                    <div className="timeline-review-box-body-inner-box">
                      <h4>
                        <span className='dos-icon'></span>
                        {formData?.RewardsDetails?.Name}
                        <span>{formatPoints(formData?.RewardsDetails?.totalpoint)} points required</span>
                      </h4>
                      
                    </div>
                  </div>
                  <div className="timeline-review-box-body-inner">
                    <div className="timeline-review-box-body-inner-box">
                      <h4>
                        <span className='com-icon'></span>
                        Complete by {formData?.Timeline?.EndDate}
                        <span>{formData?.Timeline?.Duration}</span>
                      </h4>
                      
                    </div>
                  </div>
                </div>
                <div className="timeline-review-box-lower">
                  <div className="timeline-review-box-lower-header">
                    <h4>Point Earning Commitments</h4>
                  </div>
                  <div className="timeline-review-box-lower-body">
                    {formData?.Activity?.Activity.map((commitment, index) => (
                      <div key={index} className="timeline-review-box-lower-body-box">
                        <div className="timeline-review-box-lower-body-box-left">
                          <h5>{commitment.activityType}</h5>
                         {commitment.activityType ==="Upload Invoices" ?  <p>Target: &#x20B9;{commitment.totalcount}L invoice value</p> : <p>Target: {commitment.totalcount} retailers referrals</p>}
                        </div>
                        <div className="timeline-review-box-lower-body-box-right">
                          <p>{formatPoints(commitment.points)} points</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {formData?.Activity?.BonusActivities.length > 0 && (
                  <div className="timeline-review-box-additional">
                    <div className="timeline-review-box-additional-header">
                      <h4>Additional Bonus Activities</h4>
                    </div>
                    <div className="timeline-review-box-additional-body">
                      {formData?.Activity?.BonusActivities?.map((activity, index) => (
                        <div key={index} className="timeline-review-box-additional-body-box">
                          <h5>{activity.activityType}</h5>
                          <p className="colored">{activity.totalcount} referrals committed</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <div className="timeline-review-box-alert">
                  <p>Goals cannot be modified after confirmation</p>
                </div>
                <div className="timeline-review-box-bottom">
                  <div className="timeline-review-box-bottom-inner">
                    <div className="timeline-review-box-bottom-inner-left">
                      <button className="btn btn-block white-bdr" onClick={handleBack}>
                        Back to Activities
                      </button>
                    </div>
                    <div className="timeline-review-box-bottom-inner-right">
                      <button className="btn btn-block" onClick={handleConfirm}>
                       <img src='images/circle-check.png'></img> &nbsp; Confirm Goals
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReviewContent;